import { createReducer } from "@reduxjs/toolkit";
import { createCommentThunk, createPostThunk, deletePostThunk, getCommentsThunk, getNotificationsThunk, getPostByIdThunk, getPostsThunk, getRepliesThunk, reactToPostThunk } from "../actions/social.action";

export interface SocialState {
  loading: boolean;
  posts: {
    data: any[];
    pagination: {
      currentPage: number;
      totalPages: number;
      pageSize: number;
      totalItems: number;
    };
  };
  comments: {
    data: any[];
    pagination: {
      currentPage: number;
      totalPages: number;
      pageSize: number;
      totalItems: number;
    };
  };
  replies: {
    data: any[];
    pagination: {
      currentPage: number;
      totalPages: number;
      pageSize: number;
      totalItems: number;
    };
  };
  notifications: {
    data: any[];
    pagination: {
      currentPage: number;
      totalPages: number;
    };
  };
  stats: {
    stats: {
      post: {
        [key: string]: number;
      };
    };
  };
}

const initialState: SocialState = {
  loading: false,
  posts: {
    data: [],
    pagination: {
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      totalItems: 0,
    },
  },
  comments: {
    data: [],
    pagination: {
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      totalItems: 0,
    },
  },
  replies: {
    data: [],
    pagination: {
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      totalItems: 0,
    },
  },
  notifications: {
    data: [],
    pagination: {
      currentPage: 1,
      totalPages: 0,
    },
  },
  stats: {
    stats: {
      post: {},
    },
  },
};

const SocialReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(createPostThunk.pending, (state) => {
      state.loading = true;
    })
    .addCase(createPostThunk.fulfilled, (state, action) => {
      state.loading = false;
    })
    .addCase(createPostThunk.rejected, (state) => {
      state.loading = false;
    });
  builder
    .addCase(getPostsThunk.pending, (state) => {
      state.loading = true;
    })
    .addCase(getPostsThunk.fulfilled, (state, action) => {
      state.loading = false;
      state.posts = action.payload;
    })
    .addCase(getPostsThunk.rejected, (state) => {
      state.loading = false;
    });
  builder
    .addCase(getCommentsThunk.pending, (state) => {
      state.loading = true;
    })
    .addCase(getCommentsThunk.fulfilled, (state, action) => {
      state.loading = false;
      state.comments = action.payload;
    })
    .addCase(getCommentsThunk.rejected, (state) => {
      state.loading = false;
    });
  builder
    .addCase(createCommentThunk.pending, (state) => {
      state.loading = true;
    })
    .addCase(createCommentThunk.fulfilled, (state, action) => {
      state.loading = false;
    })
    .addCase(createCommentThunk.rejected, (state) => {
      state.loading = false;
    });
  builder
    .addCase(getRepliesThunk.pending, (state) => {
      state.loading = true;
    })
    .addCase(getRepliesThunk.fulfilled, (state, action) => {
      state.loading = false;
      state.replies = action.payload;
    })
    .addCase(getRepliesThunk.rejected, (state) => {
      state.loading = false;
    });
  builder
    .addCase(reactToPostThunk.pending, (state) => {
      state.loading = true;
    })
    .addCase(reactToPostThunk.fulfilled, (state, action) => {
      state.loading = false;
    })
    .addCase(reactToPostThunk.rejected, (state) => {
      state.loading = false;
    });
  builder
    .addCase(getNotificationsThunk.pending, (state) => {
      state.loading = true;
    })
    .addCase(getNotificationsThunk.fulfilled, (state, action) => {
      state.loading = false;
      state.notifications = action.payload;
    })
    .addCase(getNotificationsThunk.rejected, (state) => {
      state.loading = false;
    });
  builder
    .addCase(deletePostThunk.pending, (state) => {
      state.loading = true;
    })
    .addCase(deletePostThunk.fulfilled, (state, action) => {
      state.loading = false;
    })
    .addCase(deletePostThunk.rejected, (state) => {
      state.loading = false;
    });
  builder
    .addCase(getPostByIdThunk.pending, (state) => {
      state.loading = true;
    })
    .addCase(getPostByIdThunk.fulfilled, (state, action) => {
      state.loading = false;
    })
    .addCase(getPostByIdThunk.rejected, (state) => {
      state.loading = false;
    });
});

export default SocialReducer;
